<template>
    <div class="login x-login-bg">
      <div class="x-login-box" id="login">
    		<el-row class="x-login-small mx-auto">
    			<el-col :span="10"><img src="../images/loginbg2.png" alt="" class="x-login-ico mx-auto"></el-col>
    			<el-col class="x-login-right" :span="14">
    				<h1>元乐培训后台管理系统</h1>
    				<div class="x-login-form">
    					<div class="form-group">
                    <span class="x-login-icon x-login-icon1"></span>
    				        <el-input v-model="userName" placeholder="请输入用户名" clearable id="logininput" ></el-input>
    				    </div>
    				    <div class="form-group">
    						<span class="x-login-icon x-login-icon2"></span>
                    <el-input v-model="password" placeholder="请输入密码" show-password clearable></el-input>
    				    </div>
    				    <div class="x-login-btnbox">
    				    	<div class="x-login-btn" @click="login" :loading="true">立即登录</div>
    				    </div>
    				    <div class="clearfix x-login-desc">
    					    <!-- <span class="float-left">找回密码请拨打客服热线</span> -->
    					</div>
    				</div>
    			</el-col>
    		</el-row>
    	</div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'login',
  data () {
    return {
        userName:'',
        password:'',
        // userName:'15954128660',
        // password:'123'
    }
  },
  methods:{
    login(){
      if(!this.userName || !this.password){
        this.$message({
          showClose: true,
          message: '用户名或密码不能为空哦',
          type: 'error'
        });
      }else{
        axios.get('/admin/index/login', {
          params: {
            username: this.userName,
            pwd:this.password
          }
        })
        .then(function (response) {
          console.log(response);
          console.log(response.data.abc);
          if(response.data.status == 1){
            localStorage.token = response.data.data.token_str;
            localStorage.user_id = response.data.data.user_id;

            this.$router.push({path:'/index/personmanage'});

            localStorage.phone = response.data.data.phone;
            localStorage.company = response.data.data.company;
            localStorage.username = response.data.data.username;
            localStorage.logo = response.data.data.logo;
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    }
  }
}
</script>

<style scoped>
.login{
  width: 100%;
  height: 100%;
}#app{
  height: 100%;
}
.x-login-bg{
	background-image:url(../images/login.png);
	width: 100%;
  height: 80%;
	background-size: cover;
	position: relative;
}img{
	max-width: 100%;
	max-height: 100%;
}.x-login-small{
	background-color: #fff;
  position: absolute;
	border-radius: 20px;
  margin: auto;
  width: 56%;
  left: 50%;
  margin-left: -28%;
  margin-top: 10%;
}.x-login-box{
	position: relative;
}.x-login-ico{
	width: 65%;
  margin: auto;
  display: block;
  margin-top: 32%;
}.x-login-right{
	padding: 80px 60px 80px 0;
  text-align: left;
}.x-login-form input{
	border: 0;
	border-bottom: 1px solid #ddd;
    padding: 20px  0 20px 50px;
    margin: 20px 0;
}.x-login-icon{
	background: url(../images/loginicon1.png)no-repeat center;
	background-size: contain;
    width: 26px;
    height: 26px;
    display: inline-block;
    position: absolute;
    top: 30px;
}.x-login-form .form-group{
	position: relative;
}.x-login-btn{
	background-color: #BDA17A;
	border-radius: 30px;
	color: #fff;
	text-align: center;
	display: block;
	height: 50px;
    line-height: 50px;
    font-size: 22px;
    cursor: pointer;
}.x-login-desc{
	padding-top: 30px;
	color: #ddd;
	font-size: 17px;
}.x-login-desc span:last-child{
	color:#BDA17A;
}.x-login-form{
	margin-top: 40px;
}.x-login-btnbox{
	margin-top: 40px;
}
</style>
<style>
.login .el-input--suffix .el-input__inner{
  border: 0!important;
  border-bottom: 1px solid #ddd!important;
  border-radius: 0!important;
  padding: 10px 0 10px 50px!important;
  background: none!important;
  margin: 20px 0!important;
  font-size: 16px!important;
  height: 48px!important;
  line-height: 48px!important;
}.login .el-input--suffix .el-input__inner{
  margin: 20px 0!important;
  height: 48px!important;
  line-height: 48px!important;
  padding-left: 40px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue